import { render } from "./SideNavBar.vue?vue&type=template&id=ab0bb3fa"
import script from "./SideNavBar.vue?vue&type=script&lang=js"
export * from "./SideNavBar.vue?vue&type=script&lang=js"

import "./SideNavBar.vue?vue&type=style&index=0&id=ab0bb3fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__